export const NODE_ENDPOINT = "https://mainnet.infura.io/v3/5f649f6c29374b33aa459d1ae69af4e8";
export const CHAIN_NAME = "mainnet";
export const ETHERSCAN_TX_URL = `https://etherscan.io/tx/`;
export const ETHERSCAN_ADDRESS_URL = `https://etherscan.io/address/`;
export const CHAIN_ID = 1;
export const HOST = "http://211.110.44.106:5413";

// export const HOST = "http://localhost:5413";
// export const CLIENT_HOST = "http://localhost:3000";
// export const CHAIN_ID = 3;
// export const NODE_ENDPOINT = "https://ropsten.infura.io/v3/5f649f6c29374b33aa459d1ae69af4e8";
// export const CHAIN_NAME = "ropsten";
// export const ETHERSCAN_TX_URL = `https://ropsten.etherscan.io/tx/`;
// export const ETHERSCAN_ADDRESS_URL = `https://ropsten.etherscan.io/address/`;

export const GAS_PRICE_API = "https://ethgasstation.info/json/ethgasAPI.json";
export const PAGE_UNIT = 5;
export const NOTICE_PAGE_UNIT = 10;
export const DONATION_LIST_PAGE_UNIT = 10;
export const ADMIN_PAGE_UNIT = 15;
export const ADMIN_EXCHANGE_UNIT = 10;
export const SECOND = 1000;
export const MINUTE = 60;

export const AMOUNT_REGEX = /^[]?\d*(\.?\d*)$/;
export const NUMBER_REGEX = /^[0-9]+$/;
